import { render } from "./transformer.vue.js?vue&type=template&id=b106afe5!=!../../../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./transformer.vue?vue&type=template&id=b106afe5"
const script = {  }

import exportComponent from "../../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__